export default __webpack_public_path__ + "static/media/photo--sm--101.cc7c4533.jpg";